
import React, { useEffect, useContext, useState } from "react";
import {
    Box,
    Center,
    Stack,
    Text,
    Link,
    Flex,
} from "@chakra-ui/layout";

import {
    Switch,
    Tooltip,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalHeader,
    ModalBody,
    ModalContent,
    FormControl,
    Input,
    ModalCloseButton,
    FormLabel,
    ModalFooter,
    Img,
    Button,
    ButtonGroup,
    useColorModeValue,
    Heading,
} from "@chakra-ui/react";
import theme from "@chakra-ui/theme";
import SearchBar from "components/search-bar";
import Tweets from "components/tweets";
import { CustomHead } from "components/custom-head";

import { useSession } from "next-auth/react";

import ProtectedRoute from "components/protected-route";
import SubscribePopup from "components/subscribe-popup";
import { Navbar } from "components/navbar";

import { getList } from "../controllers/bookmark";
import { grow, search, getKeywords, warm } from "../controllers/search";
import { useRouter } from "next/dist/client/router";
import * as analytics from "../utils/analytics";
import { firebaseClient } from "../firebaseClient";
import PuffLoader from "react-spinners/PuffLoader";
import { InfoOutlineIcon } from '@chakra-ui/icons'
import { Page } from "components/page";
import { getAccount } from "../utils/sessionHelper";
import { useFirebaseUser } from "../utils/useFirebaseUser";
import { EditKeywords } from "../components/popups/editKeywords";
import { useOnboardingSteps } from "components/onboard-panel/useOnboardingSteps";
import { useStats } from "hooks/useStats";
import { ClientPanel } from "components/queue-panels";
import { GhostwriterPanel } from "components/ghostwriter/ghostwriterPanel";
import { setInLocalStorage } from "utils/helpers";
import { variant } from 'theme/names';
import { TweetContext } from "context/tweetContext";


let modes = [
    "client",
    "ghostwriter",
];

export const Collaboration = ({query}) => {

  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"
  const router = useRouter();
    const [refresh, refresher] = React.useState({});
    const [hasFetched, setHasFetched] = React.useState(false);
    const [mode, setModeInternal] = React.useState("client");
    const isAuthenticated = useFirebaseUser();
    const tweetContext: any = useContext(TweetContext);

    const changeTabFromQuery = (query) => {
        if (modes.includes(query.mode)) {
            setModeInternal(query.mode);
        }
    }

    useEffect(() => {
        changeTabFromQuery(query);
    }, [query.mode]);

    useEffect(() => {
        if (isAuthenticated && !hasFetched) {

        }
    }, [session, isAuthenticated]);

    const setMode = (newMode) => {
        router.push({
            pathname: '/collaboration',
            query: { mode: newMode }
        }, undefined, { shallow: false });
        setModeInternal(newMode);
        setInLocalStorage("collaboration_last_mode", newMode);
    };

    if (!loading && !session) {
        return <ProtectedRoute />;
    }

    const bgColor = useColorModeValue("gray.200", "gray.600");
    const bgColorHover = useColorModeValue("gray.100", "gray.700");

    return (
      <Page>
        <Flex justifyContent="space-between">
          <Flex mb={0} gap={3} flexDirection={{ base: "column", md: "row" }}>
            <Flex>
              <Heading variant={variant.Heading.pageTitle} as="h1">
                Collaboration
              </Heading>
            </Flex>
          </Flex>
          <Flex ml={2}>
            <ButtonGroup isAttached variant="light">
              <Button
                // variant="outline"
                variant={mode !== "client" ? variant.Button.lightSelected : variant.Button.light}

                // bg={mode == "ghostwriter" ? bgColor : "none"}
                // _focus={{ boxShadow: "none" }}
                // cursor={mode == "ghostwriter" ? "default" : "pointer"}
                // _hover={{ bg: mode == "ghostwriter" ? bgColor : bgColorHover }}
                // size="sm"
                // fontSize="12px"
                mr="-px"
                onClick={() => {
                  setMode("ghostwriter");
                }}
                isDisabled={
                  session?.user?.data?.subscription?.isInOrg &&
                  session?.user?.data?.subscription?.orgRole == "Member"
                }
              >
                ✍️ Writer mode
              </Button>
              <Button
                // variant="outline"
                variant={mode === "client" ? variant.Button.lightSelected : variant.Button.light}
                // bg={mode == "client" ? bgColor : "none"}
                // _focus={{ boxShadow: "none" }}
                // cursor={mode == "client" ? "default" : "pointer"}
                // _hover={{ bg: mode == "client" ? bgColor : bgColorHover }}
                // size="sm"
                // fontSize="12px"
                onClick={() => {
                  setMode("client");
                }}
              >
                🕴️ Client mode
              </Button>
            </ButtonGroup>
          </Flex>
        </Flex>
        <Box mb={5} mt="2">
          {mode == "client" && <ClientPanel isSelected={true} />}
          {mode == "ghostwriter" && <GhostwriterPanel query={query} />}
        </Box>
      </Page>
    );
};

Collaboration.getInitialProps = async ({query}) => {
    // console.log(query);
    return {query};
  }
  
  export default Collaboration;
  